import type { SidebarState } from "./sidebar.types";

/**
 * Default sidebar state for new users or reset scenarios
 */
export const DEFAULT_SIDEBAR_STATE: SidebarState = {
  isCollapsed: false,
  dismissedTileIds: {},
  expandedMenuIds: [],
  savedExpandedMenuIds: [],
};

/**
 * Tile IDs that can be dismissed in the sidebar
 */
export const SIDEBAR_TILES = {
  MIGRATION_PROMPT: "migration-prompt",
} as const;

export type SidebarTileId = (typeof SIDEBAR_TILES)[keyof typeof SIDEBAR_TILES];

export const MAX_ACCOUNTS_TO_LIST = 10;
